/**
 * AI Assistant teaser — P1 placeholder. Backend lands in P2.
 * Establishes AI visual language (indigo accent) and creates anticipation.
 */

interface Props {
  readonly onBack: () => void;
}

export function AIAssistant({ onBack }: Props): React.ReactElement {
  return (
    <div className="app-page">
      <div className="ds-appbar">
        <button className="ds-iconbtn" onClick={onBack}>&#8249; Back</button>
        <h1>AI Assistant</h1>
      </div>

      <div className="ds-card" style={{
        textAlign: "center",
        padding: "48px 24px",
        border: "2px solid var(--ai, #6366f1)",
        marginTop: 16,
      }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>🤖</div>
        <h2 className="ds-heading" style={{ marginBottom: 8 }}>Coming Soon</h2>
        <p className="ds-caption" style={{ maxWidth: 400, margin: "0 auto", lineHeight: 1.6 }}>
          Ask anything about your matches — AI-powered insights, strategy suggestions,
          player analysis, and match summaries. Powered by Sports OS Intelligence.
        </p>
      </div>
    </div>
  );
}
